import styled from 'styled-components';

const FAQCompStyle = styled.section`
	--marginT: var(--sp12x);
	--titleMarginB: var(--sp8x);
	--descMarginB: var(--sp8x);
	--faqItemsMTop: var(--sp5x);
	--gapCol: var(--sp2x);
	--gapRow: var(--sp2x);

	--faqItemBlockDistance: var(--sp9x);

	/* margin-top: var(--marginT); */

	.faq-version {
		.title-faq {
			margin-bottom: var(--titleMarginB);
		}

		.desc-faq {
			margin-bottom: var(--descMarginB);
		}

		.faq-tab-wrapper {
			display: flex;
			flex-wrap: wrap;
			column-gap: var(--gapCol);
			row-gap: var(--gapRow);

			position: relative;

			&:after {
				content: '';
				position: absolute;
				bottom: -50%;
				left: 0;
				width: 100%;
				height: 700%;
				background-color: var(--lightGray1000);
				z-index: 99;
			}
		}
	}

	.faq-inner-items {
		overflow: hidden;
	}

	.faq-sticky-wrapper,
	.tab-wrapper {
		will-change: transform;
	}

	.faq-item-block {
		margin-top: var(--faqItemBlockDistance);
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginT: var(--sp10x);
		--titleMarginB: var(--sp8x);
		--descMarginB: var(--sp7x);
		--faqItemBlockDistance: var(--sp8x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginT: var(--sp9x);
		--titleMarginB: var(--sp5x);
		--descMarginB: var(--sp5x);
		--faqItemBlockDistance: var(--sp5x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp7x);
		--titleMarginB: var(--sp4x);
		--descMarginB: var(--sp4x);
		--faqItemBlockDistance: var(--sp4x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--faqItemBlockDistance: var(--sp4x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp6x);
		--titleMarginB: var(--sp3x);
		--gapCol: var(--sp1-5x);
		--gapRow: var(--sp1-5x);
		--faqItemBlockDistance: var(--sp4x);

		.faq-version .faq-tab-wrapper:after {
			bottom: -30%;
		}
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--marginT: var(--sp5x);
		--descMarginB: 0;
		--faqItemBlockDistance: 0;

		.faq-tab-wrapper {
			display: none;
		}

		.faq-items {
			margin-top: var(--faqItemsMTop);
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--marginT: var(--sp6x);
		--faqItemsMTop: var(--sp4x);
		--gapCol: var(--sp1x);
	}
`;

export default FAQCompStyle;
